import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../../redux-stores/store';
import { Configurations } from '../../redux-stores/slices/authSlice';

const ifConfigured = (WrappedComponent: React.FC, configurationKey: string, redirectTo?: string): React.FC => {
    return (props: any) => {

        const configruationsData = useSelector((state: RootState) => state.auth.configurations);
        const configruations = configruationsData ?? {} as Configurations;
        if (configruations[configurationKey] !== 'y') {
            if (redirectTo) {
                return <Navigate to={redirectTo} />
            }
            return <div>Not Allowed</div>
        }

        return <WrappedComponent {...props} />;
    };
};

export default ifConfigured;